export enum CloudWorkloadSecurityAccountStatus {
  NOT_CREATED,
  CREATED,
  EXPIRED,
}

export enum CloudWorkloadSecurityCompanyType {
  CUSTOMER = 1,
  PARTNER,
}

export enum AccountAction {
  CREATE = 'create-account',
  CONSOLE = 'open-console',
}

export interface CloudWorkloadSecurityCompanyRecord {
  _id: string;
  companyName: string;
  companyType: CloudWorkloadSecurityCompanyType;
  accountStatus: CloudWorkloadSecurityAccountStatus;
  daysUntilExpire?: number;
}
